<template>
  <VDataTable
    :headers="headers"
    :items="items"
    no-data-text="Keine Daten verfügbar"
    :loading="loading"
  >
    <template #body="{ items }">
      <tbody>
        <tr
          v-for="item in items"
          :key="item.id"
        >
          <td class="cell no-padding text-left">
            {{ item.employee.firstName }}
          </td>
          <td class="cell no-padding text-left">
            {{ item.employee.lastName }}
          </td>
          <td class="cell no-padding text-left">
            {{ item.order.name }}
          </td>
          <td class="cell no-padding text-right">
            {{ item.date | formatDate("dddd, Do MMMM YYYY") }}
          </td>
          <td class="cell no-padding text-left">
            {{ $vuetify.lang.t("$vuetify.enum.worklogType." + item.type) }}
          </td>
          <td class="cell no-padding text-right">
            {{ item.start }}
          </td>
          <td class="cell no-padding text-left">
            {{ item.createdBy }}
          </td>
          <td class="cell no-padding text-right">
            {{ item.createdAt | formatDate("dddd, D. MMMM YYYY HH:mm:ss") }}
          </td>
        </tr>
      </tbody>
    </template>
  </VDataTable>
</template>

<script>
  import WorklogServiceV2 from "@/service/WorklogServiceV2";

  export default {
    data: () => ({
      items: [],
      loading: false,
      headers: [
        {
          text: "Vorname",
          align: "left",
          value: "employee.firstName"
        },
        {
          text: "Nachname",
          align: "left",
          value: "employee.lastName"
        },
        {
          text: "Auftrag",
          align: "left",
          value: "order.name"
        },
        {
          text: "Datum",
          align: "right",
          value: "date"
        },
        {
          text: "Typ",
          align: "left",
          value: "type"
        },
        {
          text: "Uhrzeit",
          align: "right",
          value: "start"
        },
        {
          text: "Von",
          align: "left",
          value: "createdBy"
        },
        {
          text: "Einstempeluhrzeit",
          align: "right",
          value: "createdAt"
        }
      ]
    }),
    created () {
      this.init();
    },
    methods: {
      init: function () {
        this.loading = true;
        WorklogServiceV2.getOpenWorklogs()
          .then(worklogs => {
            this.items = worklogs;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
